import { keyframes } from 'tss-react';

const fadeInKeyframes = keyframes({
    from: { opacity: 0 },
    to: { opacity: 1 },
});

export default theme => ({
    root: {
        backgroundColor: theme.palette.background.default,
        height: '100vh',
    },
    grid: {
        height: '100%',
        overflowY: 'auto',
    },
    quoteWrapper: {
        animationName: `${fadeInKeyframes}`,
        animationDuration: '600ms',

        [theme.breakpoints.down('lg')]: {
            display: 'none',
        },
    },
    contentWrapper: {
        animationName: `${fadeInKeyframes}`,
        animationDuration: '600ms',
    },
});
